import FormInputValueValidationError, {
  IFormInputValueValidationError
} from "../../model/validation/FormInputValueValidationError";
import { IFormSectionQualifierPresentationModel } from "../../presenter/form/model/FormSectionQualifierPresentationModel";
import { IFormSectionPresentationModel } from "../../presenter/form/model/FormSectionPresentationModel";
import { AttributeFormConstants } from "../Constants";

const REQUIRED_VALUE_MISSING_MSG_TRANSLATION_KEY =
  "form_validation.required_value_missing_msg";
const SEGMENT_NOT_FILLED_TRANSLATION_KEY =
  "form_validation.required_segment_not_filled";

export interface IFormValidator {
  validateAttributeValues(
    section: IFormSectionPresentationModel
  ): IFormInputValueValidationError[];
}
const isQualifierChanged = (qualifier) => {
  let valueExists: boolean = false;
  qualifier.attributes.forEach((attribute) => {
    attribute.values.forEach((value) => {
      if (value.value !== null && value.value !== undefined) {
        valueExists = true;
      }
    });
  });
  return valueExists;
};
const getChangedQualifiers = (qualifiers) => {
  let changedQualifiers: IFormSectionQualifierPresentationModel[] = [];
  qualifiers.forEach((qualifier) => {
    if (isQualifierChanged(qualifier)) {
      changedQualifiers.push(qualifier);
    }
  });
  return changedQualifiers;
};
const areThereEnoughValues = (
  qualifier: IFormSectionQualifierPresentationModel
) => {
  let validationErrors: IFormInputValueValidationError[] = [];
  qualifier.attributes?.forEach((attribute) => {
    if (attribute.values.length < 1) {
      validationErrors.push(
        FormInputValueValidationError({
          formSectionId: qualifier.formSectionId,
          messageTranslationCode: SEGMENT_NOT_FILLED_TRANSLATION_KEY
        })
      );
    }
  });
  return validationErrors;
};
const getValidationErrors = (
  qualifier: IFormSectionQualifierPresentationModel
) => {
  let validationErrors: IFormInputValueValidationError[] = [];
  qualifier.attributes?.forEach((attribute) => {
    attribute.values.forEach((values) => {
      if (
        attribute.attributeType !==
          AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA &&
        (values.value === undefined || values.value === null) &&
        values.isRequiredFlagVisible
      ) {
        validationErrors.push(
          FormInputValueValidationError({
            formAttributeId: values.formAttributeId,
            messageTranslationCode: REQUIRED_VALUE_MISSING_MSG_TRANSLATION_KEY
          })
        );
      }
    });
  });
  return validationErrors;
};
const onSectionRequiredValidation = (
  section: IFormSectionPresentationModel
) => {
  let validationErrors: IFormInputValueValidationError[] = [];
  if (section.maxNumber === -1) {
    section.qualifiers?.forEach((qualifier) => {
      Array.prototype.push.apply(
        validationErrors,
        areThereEnoughValues(qualifier)
      );
      Array.prototype.push.apply(
        validationErrors,
        getValidationErrors(qualifier)
      );
    });
  } else {
    section.qualifiers?.forEach((qualifier) => {
      Array.prototype.push.apply(
        validationErrors,
        getValidationErrors(qualifier)
      );
    });
  }
  return validationErrors;
};

const FormValidator = (): IFormValidator => {
  return {
    validateAttributeValues(
      section: IFormSectionPresentationModel
    ): IFormInputValueValidationError[] {
      let validationErrors: IFormInputValueValidationError[] = [];
      if (section.isRequiredFlagVisible) {
        Array.prototype.push.apply(
          validationErrors,
          onSectionRequiredValidation(section)
        );
      } else {
        const changedQualifiers = getChangedQualifiers(section.qualifiers);
        if (changedQualifiers.length > 0) {
          Array.prototype.push.apply(
            validationErrors,
            onSectionRequiredValidation(section)
          );
        }
      }
      return validationErrors;
    }
  };
};

export default FormValidator;
